export default "__VITE_ASSET__cpNYzo65__"